.toggle {
  background-color: var(--bloom-colors-header-contrast);
  border-radius: 16px;
  border: none;
  color: var(--bloom-colors-header-contrast-text-label);
  column-gap: 16px;
  cursor: pointer;
  display: grid;
  grid-template:
    "title modes" max-content "storeName modes" 1fr / 1fr max-content;
  padding: 6px 16px;
  text-align: left;
  width: 100%;
}

.toggle--hidden {
  display: none;
}

.grid--title {
  grid-area: title;
}

.grid--storeName {
  grid-area: storeName;
}

.grid--modes {
  align-items: center;
  grid-area: modes;
  height: 100%;
}

.lineHeight {
  line-height: 18px;
}

.skeleton {
  padding: 0;
  height: 44px;
}

@supports (-webkit-line-clamp: 2) {
  .storeName {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

@media all and (--reefer-media-tablet-min) {
  .toggle {
    grid-template:
      "title title" 1fr "storeName modes" 1fr / 1fr max-content;
  }

  .skeleton {
    height: 48px;
  }

  .storeName {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    display: -webkit-box;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
